import styled from 'styled-components';
import { APPS_PHONE_MEDIA } from '../apps.constants';

export const HeaderBar = styled.header`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  padding: 12px 20px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.outlineVariant};

  ${APPS_PHONE_MEDIA} {
    flex-wrap: nowrap;
    padding: 8px 12px;
  }
`;

export const HeaderTitle = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.onSurface};
`;

export const HeaderChips = styled.div`
  display: flex;
  flex: none;
  align-items: center;
  gap: 6px;
`;

export const HeaderActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  margin-left: auto;

  ${APPS_PHONE_MEDIA} {
    flex-wrap: nowrap;
  }
`;
